import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
    barraFiltroDiv: {
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center'
    },
    barraFiltro: {
        width: '95%',
        backgroundColor: 'white',
        minHeight: 106,
        boxShadow: '0 2px 0 0 #dfdfe6',
        padding: 20,
        display: 'flex',
        alignItems: 'center',
        zIndex: 0,
        marginTop: props => props.marginTop,
        '& button': {
            width: '100%',
        }
    },
    formTabPanel: {
        margin: '24px 24px 0px'
    },
    headerAppBar: {
        margin: '0px 16px 0px'
    },
    contentTabPanel: {
        margin: '16px 24px 0px'
    },
    footerPagination: {
        margin: '16px'
    },
})

export default useStyles